import SectionHeading from "./SectionHeading";
import { trendingTopics } from "@/mocks/home";

interface TrendingTopicsProps {
  notify: (message: string) => void;
}

export default function TrendingTopics({ notify }: TrendingTopicsProps) {
  const handleOpen = (title: string) => {
    notify(`「${title}」详情整理中，先收藏本页不错过更新`);
  };

  return (
    <section id="trending" className="bg-background-100 py-14 md:py-20 px-4 md:px-10">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          eyebrow="今日热榜导航"
          title="大家今天在聊什么，一条摘要说清楚"
          desc="按讨论热度自动排序，每条只给一句摘要，不堆废话，点进去前就能判断值不值得看。"
        />
        <button
          type="button"
          onClick={() => notify("完整榜单每日更新，记得常回来看看")}
          className="inline-flex items-center justify-center gap-1.5 h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap shrink-0"
        >
          <i className="ri-refresh-line" />
          刷新榜单
        </button>
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
        {trendingTopics.map((topic) => (
          <article
            key={topic.rank}
            className="flex gap-4 rounded-lg bg-background-50 border border-background-200 p-4 hover:border-primary-300 transition-colors"
          >
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-md overflow-hidden shrink-0">
              <img
                src={topic.image}
                alt={`${topic.title} 相关配图`}
                title={`${topic.title} 导航入口`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1 flex flex-col">
              <div className="flex items-center gap-2">
                <span className="font-heading text-xs font-bold text-accent-700">{topic.rank}</span>
                <span className="h-5 px-2 rounded-full bg-secondary-100 text-secondary-800 text-[11px] inline-flex items-center">
                  {topic.tag}
                </span>
              </div>
              <h3 className="mt-1.5 text-sm md:text-base font-medium text-foreground-950 leading-snug">
                {topic.title}
              </h3>
              <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-600 line-clamp-2">
                {topic.summary}
              </p>
              <div className="mt-auto pt-2.5 flex items-center justify-between">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-fire-line text-primary-500" />
                  {topic.heat}
                </span>
                <button
                  type="button"
                  onClick={() => handleOpen(topic.title)}
                  className="text-xs font-medium text-primary-600 hover:text-primary-700 inline-flex items-center gap-1 cursor-pointer whitespace-nowrap"
                >
                  查看整理
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}